// This is used client and server side, so can't use ES6 exports
module.exports = (searchRequest) => {
    const boundingBox = searchRequest.boundingBox;
    if (boundingBox) {
        return (
            !!boundingBox.maxLat &&
            !!boundingBox.maxLng &&
            !!boundingBox.minLat &&
            !!boundingBox.minLng
        );
    }

    return (
        !!searchRequest.neLat &&
        !!searchRequest.neLong &&
        !!searchRequest.swLat &&
        !!searchRequest.swLong &&
        !!searchRequest.zoom
    );
};
